import React, { Fragment } from 'react';
import RocketMatterCaseFolderSettingsForm from "./RocketMatterCaseFolderSettingsForm";
import useDataApi from "utils/useDataApi";
import request from 'superagent';
import Notification, {notify} from 'common/Notification';
import { FORM_ERROR } from 'react-final-form';

const onSave = (connectionId, casefolderId, settings) => {
  return request.post(`/rpc/integrations/connections/${connectionId}/rocketmatter/${casefolderId}`)
    .send(settings)
    .then(
      res => {
        notify.success('RocketMatter CaseFolder Settings Saved');
      },
      errRes => {
        return {[FORM_ERROR]: 'Error Saving'};
      }
    );
};

export default function({ connection_id, casefolder_id }) {
  const [{data}] = useDataApi(
    `/rpc/integrations/connections/${connection_id}/rocketmatter/${casefolder_id}`,
    {}
  );

  return (
    <Fragment>
      <Notification/>
      <RocketMatterCaseFolderSettingsForm
        connectionId={connection_id}
        caseFolderId={casefolder_id}
        onSave={settings => onSave(connection_id, casefolder_id, settings)}
        settings={data}
      />
    </Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/CaseFolder/Integrations/RocketMatter/RocketMatterCaseFolderSettings.jsx